import React, {useContext, useEffect, useState} from 'react';
import './login.scss';
import {useNavigate} from "react-router-dom";
import {Formik} from "formik";
import * as Yup from "yup";
import {Button, InputField, Loading} from "components";
import EMAIL_ICON from "assets/icons/email_icon.svg";
import PASSWORD_ICON from "assets/icons/password_icon.svg";
// import {useLoginMutation} from "../../../operations/mutations/useLoginMutation";
import {useLoginMutation} from "operations/mutations";
import jwt_decode from "jwt-decode";
import {SessionContext} from "../../../providers/SessionProvider";

export const LoginFormValidation = Yup.object().shape({
    identifier: Yup.string().required('email is required').email('Invalid email address'),
    password: Yup.string().required('Password is required'),
})

const ERROR_ICON = <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.00195 1.00024L11.0004 10.9987' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
    <path d='M10.9985 1L1.00012 10.9984' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
</svg>;

const Login = () => {
    const navigate = useNavigate()
    const {mutateAsync, isError, isLoading} = useLoginMutation();
    const {createSession} = useContext(SessionContext);
    const [isLoginError, setLoginError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>(
        'A connectivity issue has occurred. Please check your connection and try again.'
    );

    useEffect(() => {
        setLoginError(isError);
    }, [isError]);

    useEffect(() => {
        setErrorMessage((msg) => (msg?.replace(/(<([^>]+)>)/ig, '')
            .replace("Error:", '')
            .replace('Lost your password?', '')))
    }, [isError]);

    const onSubmit = async (values: any, {setSubmitting}: any) => {

        await mutateAsync(values)
            .then(data => {
                const payload: any = jwt_decode(data?.data.jwt);

                // const userInfo = payload.data;
                payload && createSession({
                    isActive: true,
                    isAuth: true,
                    exp: payload.exp,
                    // payload: userInfo,
                    payload: data.data.user,
                    token: data.data.jwt,
                });
                setSubmitting(false);
                navigate('/app/dashboard')
            })
            .catch((err) => {
                setErrorMessage(err.response.data.message)
            })
        setSubmitting(false);
    }
    return (
        <div className={'login'}>
            <h1>Hi, Welcome Back!</h1>
            <p>Login and find out how we can help your business today.</p>
            {isLoginError && <div className='login_error'>
                <div className='login_error_circle' onClick={() => setLoginError(false)}>
                    {ERROR_ICON}
                </div>
                <h1>Oops!</h1>
                <p>{errorMessage}</p>
            </div>}
            {isLoading && (
                <div className={'login_loading'}>
                    <Loading/>
                </div>
            )}
            <Formik
                validateOnMount={false}
                initialValues={{identifier: "", password: ""}}
                validationSchema={LoginFormValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>

                        <div>
                            <InputField
                                type="text"
                                classname="signup__input"
                                placeholder={"Email"}
                                name="identifier"
                                onblur={handleBlur}
                                error={errors.identifier && touched.identifier}
                                onchange={handleChange}
                                message={errors.identifier && touched.identifier && errors.identifier}
                                inputValue={values.identifier}
                                image={EMAIL_ICON}
                            />
                            <InputField
                                type="password"
                                classname="signup__input"
                                placeholder={"Password"}
                                name="password"
                                onblur={handleBlur}
                                error={errors.password && touched.password}
                                onchange={handleChange}
                                message={errors.password && touched.password && errors.password}
                                inputValue={values.password}
                                image={PASSWORD_ICON}
                            />
                            <span id={'forgot-password'} onClick={() => navigate('/forgot')}>Forget Password?</span>

                            <Button type={"primary"} isSubmit={true} text={"Login"}/>

                        </div>

                    </form>
                )}
            </Formik>
            <p className={'tertiary_cta'}>Don't have an account? <span
                onClick={() => navigate("/registration")}>Sign Up</span>
            </p>
        </div>
    );
};

export default Login;
